<template>
  <div class="wt-ai-prompts-list" v-if="prompts && prompts.length">
    <div class="wt-ai-prompts-header">
      <span class="title">AI Prompts</span>
      <span
        v-if="hiddenCount > 0"
        class="wt-ai-prompts-toggle"
        @click="expanded = !expanded"
      >
        <span v-if="!expanded">(Show {{ hiddenCount }} more)</span>
        <span v-else>(Show less)</span>
      </span>
    </div>
    <div class="wt-ai-prompts-items" :class="{ '-expanded': expanded }">
      <div
        v-for="(prompt, index) in visiblePrompts"
        :key="index"
        class="wt-ai-prompt-item"
        :title="sanitizeTitle(prompt)"
      >
        <span class="wt-ai-prompt-text">{{ prompt }}</span>
        <span class="wt-ai-prompt-copy-wrap" :ref="'copy-' + index">
          <i
            class="wticon wticon-copy wt-ai-prompt-copy"
            :class="{ '-copied': copiedIndex === index }"
            @click="copyPrompt($event, prompt, index)"
          ></i>
          <span
            v-if="copiedIndex === index"
            class="wt-ai-prompt-tooltip"
            :style="tooltipStyle"
            >Copied!</span
          >
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    prompts: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      expanded: false,
      copiedIndex: null,
      tooltipStyle: {},
    };
  },

  computed: {
    visiblePrompts() {
      if (!this.prompts) return [];
      return this.expanded ? this.prompts : this.prompts.slice(0, 3);
    },
    hiddenCount() {
      if (!this.prompts) return 0;
      return Math.max(0, this.prompts.length - 3);
    },
  },

  methods: {
    sanitizeTitle(text) {
      if (!text) return '';
      return text
        .replace(/[<>"'&]/g, '')
        .replace(/[\r\n]+/g, ' ')
        .trim();
    },
    copyPrompt(event, text, index) {
      const rect = event.target.getBoundingClientRect();
      this.tooltipStyle = {
        left: rect.left + rect.width / 2 + 'px',
        top: rect.top + 'px',
      };
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.copiedIndex = index;
          setTimeout(() => {
            this.copiedIndex = null;
          }, 1500);
        })
        .catch(() => {
          // Fallback: silently fail if clipboard not available
        });
    },
  },
};
</script>

<style scoped>
.wt-ai-prompts-list {
  margin-top: 8px;
}

.wt-ai-prompts-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.wt-ai-prompts-header .title {
  width: auto !important;
  margin-right: 10px !important;
  padding: 0 !important;
}

.wt-ai-prompts-items {
  max-height: 200px;
  overflow-y: auto;
}

.wt-ai-prompts-items.-expanded {
  max-height: none;
}

.wt-ai-prompt-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.wt-ai-prompt-item:last-child {
  border-bottom: none;
}

.wt-ai-prompt-text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  font-style: italic;
}

.wt-ai-prompt-copy-wrap {
  position: relative;
  margin-left: 8px;
  flex-shrink: 0;
}

.wt-ai-prompt-copy {
  cursor: pointer;
  color: #9b9b9b;
  font-size: 14px;
  transition: color 0.2s;
}

.wt-ai-prompt-copy:hover {
  color: #4a4a4a;
}

.wt-ai-prompt-copy.-copied {
  color: #06a9f4;
}

.wt-ai-prompt-tooltip {
  position: fixed;
  transform: translateX(-50%) translateY(-100%);
  margin-top: -8px;
  background: #000;
  color: #fff;
  font-size: 11px;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 9999;
}

.wt-ai-prompt-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 4px solid transparent;
  border-top-color: #000;
}

.wt-ai-prompts-toggle {
  cursor: pointer;
  font-size: 13px;
  color: #06a9f4;
}

.wt-ai-prompts-toggle:hover {
  text-decoration: underline;
}
</style>
